import React from 'react';
import { compose } from 'redux';
import { LocalizedMessage, LocalizedStandardDate } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Core components
import TableRow from 'components/core/table/TableRow';
import TableCell from 'components/core/table/TableCell';
import Tooltip from 'components/core/Tooltip';
// Models
import { status } from 'models/deviceBatch';
// Custom
import { listRowSpecsShape, deviceBatchDataShape } from 'constants/PropTypesShapes';
import { showDeviceBatchesPath } from 'production/navigation';
import withLoading from 'hocs/WithLoading';
import AppIcon from 'components/icons/AppIcon';
import { EditIconButton } from 'components/buttons/IconButtons';
import TruncatedTooltipText from 'components/misc/TruncatedTooltipText';
import DeviceModelIdDesc from 'production/assets/deviceModel/DeviceModelIdDesc';

const DeviceBatchStatus = ({ deviceBatch }) => {
  const { labelId, icon, color } = status(deviceBatch);
  return (
    <div className="d-flex align-items-center">
      <Tooltip content={<LocalizedMessage id={labelId} />}>
        <AppIcon color={color} id={icon} />
      </Tooltip>
    </div>
  );
};

DeviceBatchStatus.propTypes = {
  deviceBatch: deviceBatchDataShape.isRequired,
};

const DeviceBatchRow = React.forwardRef(({
  deviceBatch, rowSpecs, handleStartLoading,
}, ref) => {
  const { id: deviceBatchId } = deviceBatch;

  return (
    <TableRow
      ref={ref}
      element={deviceBatch}
      rowSpecs={rowSpecs}
      actions={[
        <EditIconButton key="bEdit" onClick={handleStartLoading} path={showDeviceBatchesPath(deviceBatchId)} />,
      ]}
    >
      <TableCell>
        <TruncatedTooltipText><LocalizedStandardDate value={deviceBatch.date} /></TruncatedTooltipText>
      </TableCell>
      <TableCell>
        <TruncatedTooltipText>{deviceBatch.name}</TruncatedTooltipText>
      </TableCell>
      <TableCell className="hidden-sm-down">
        <DeviceModelIdDesc deviceModelId={deviceBatch.device_model_id} />
      </TableCell>
      <TableCell className="table-content-1 table-content-center hidden-sm-down" noPadding>
        <DeviceBatchStatus deviceBatch={deviceBatch} />
      </TableCell>
      <TableCell className="hidden-sm-down">
        <TruncatedTooltipText>
          {deviceBatch.commit_date && <LocalizedStandardDate value={deviceBatch.commit_date} />}
        </TruncatedTooltipText>
      </TableCell>
    </TableRow>
  );
});

DeviceBatchRow.displayName = 'DeviceBatchRow';

DeviceBatchRow.propTypes = {
  deviceBatch: deviceBatchDataShape.isRequired,
  rowSpecs: listRowSpecsShape.isRequired,
  handleStartLoading: PropTypes.func.isRequired,
};

module.exports = compose(
  withLoading,
)(DeviceBatchRow);



// WEBPACK FOOTER //
// ./routes/app/routes/production/assets/deviceBatch/DeviceBatchRow.js